export default __webpack_public_path__ + "static/media/granada-centro-nuevo.4922f299.png";